import { createApi } from '@reduxjs/toolkit/query/react';
import azureBaseQuery from './azureBaseQuery';

export const azureStorageApi = createApi({
  reducerPath: 'azureStoreApi',
  baseQuery: azureBaseQuery,
  endpoints: () => ({}),
});
